<template>
    <div class="scc-container">
        <footer class="scc-app-sub-footer-alternative" v-bind:class="singleClass">
            <div v-if="smallLinks && smallLinks.length > 0" class="scc-app-sub-footer-alternative__small-links">
                <template v-for="(link, i) in smallLinks">
                    <SccLink
                        v-if="link.link"
                        :key="link.link + i"
                        class="scc-app-sub-footer-alternative__small-link"
                        :to="link.link"
                    >
                        {{ link.name }}
                    </SccLink>
                    <span
                        v-else-if="link.name.includes('instellingen')"
                        :key="i"
                        class="scc-app-sub-footer-alternative__small-link"
                        @click="openCookieSettings"
                    >
                        {{ link.name }}
                    </span>
                    <span v-else :key="i" class="scc-app-sub-footer-alternative__small-link">{{ link.name }}</span>
                </template>
            </div>
            <span class="scc-app-sub-footer-alternative__copyright">
                {{ copyright }}
            </span>
        </footer>
    </div>
</template>

<script>
import './app-sub-footer-alternative.scss';
import SccLink from '../global/SccLink';

export default {
    name: 'AppSubFooterAlternative',
    components: { SccLink },
    __editor: {
        requiredData: ['game'],
        fields: {
            smallLinks: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        name: {
                            widget: 'text',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
        },
    },
    props: {
        game: {
            type: Object,
        },
        smallLinks: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        singleClass() {
            // console.log(this.smallLinks, this.smallLinks.length === 0);
            return {
                'scc-app-footer-alternative--single': this.smallLinks.length === 0,
            };
        },
        copyright() {
            return `Copyright © ${new Date().getFullYear()} ${this.game?.name || ''} - Alle rechten voorbehouden`;
        },
    },
    methods: {
        openCookieSettings() {
            window?.dsmConsent?.showPopup();
        },
        logSocial(social) {
            const dimensions = { social_name: social.name, social_action: 'redirect' };
            this.$logger?.logSocialInteraction(dimensions);
        },
    },
};
</script>
